import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const CORE_WIRING: Wiring = {
  [EVENTS.InfiniteScroll]: [
    WIRES.keepPreviousResults,
    WIRES.increasePage,
    WIRES.dispatchSearch
  ],
  [EVENTS.InfiniteScrollNoResults]: [
    WIRES.increaseNoResultsRecommendationsPage,
    WIRES.getNoResultsRecommendations
  ],
  [EVENTS.InfiniteScrollEmptySearch]: [
    WIRES.increaseEmptySearchRecommendationsPage,
    WIRES.getEmptySearchRecommendations
  ],
  [EVENTS.Scroll]: [
    WIRES.scrollStopped,
    WIRES.emitUserAcceptedQuery,
    WIRES.closeEmpathize
  ],
  [EVENTS.ScrollDirectionChanged]: [
    WIRES.changeScrollDirection
  ],
  [EVENTS.ScrollOffsetChanged]: [
    WIRES.changeScrollOffset
  ],
  [EVENTS.ScrollAboutToEnd]: [
    WIRES.emitInfiniteScrollType
  ],
  [EVENTS.ScrollEnded]: [
    WIRES.emitResultsEnd
  ],
  [EVENTS.ScrollStopped]: [
    WIRES.replaceURL
  ],
  [EVENTS.ScrollEnabled]: [
    WIRES.setScrollEnabled
  ],
  [EVENTS.SetHorizontalScrollType]: [
    WIRES.setHorizontalScrollType
  ],
  [EVENTS.EmpathyXCreated]: [
    WIRES.loadPreselectedFilters,
    WIRES.loadStateFromURL,
    WIRES.replaceURL,
    WIRES.queryOriginUrl,
    WIRES.dispatchSearch,
    WIRES.trackPendingURLClick,
    WIRES.getTermSuggestions,
    WIRES.getIdentifierSuggestions,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.OpenEmpathyX]: [
    WIRES.calculateCorePosition,
    WIRES.setFacetsFromPreselectedFiltersIfThereAre,
    WIRES.checkCompulsoryFacets,
    WIRES.getPopularSearches,
    WIRES.loadQueryHistory,
    WIRES.loadSessionQueryHistory,
    WIRES.loadClickedResultHistory,
    WIRES.openEmpathyX,
    WIRES.callGetWishlistClientEvent,
    WIRES.getEmptySearchRecommendations,
    WIRES.getResultsSuggestions,
    WIRES.getNextQueriesOfSessionQueryHistory,
    WIRES.trackOpen
  ],
  [EVENTS.CloseEmpathyX]: [
    WIRES.disableOpenFinished,
    WIRES.closeEmpathyX,
    WIRES.clearInputQuery,
    WIRES.clearSearch,
    WIRES.clearEmptySearchRecommendations,
    WIRES.clearNoResultsRecommendations,
    WIRES.clearDiscoveryWall,
    WIRES.clearRelatedTags,
    WIRES.clearNextQueriesState,
    WIRES.loadPreselectedFilters,
    WIRES.pushURL,
    WIRES.trackClose,
    WIRES.resetScrollDirection,
    WIRES.resetScrollOffset
  ],
  [EVENTS.OpenFinished]: [
    WIRES.enableOpenFinished
  ],
  [EVENTS.TogglePanel]: [
    WIRES.toggleFacetsGroupPanel,
    WIRES.resetFacetsCollapse,
    WIRES.collapseSort
  ],
  [EVENTS.ConfigChanged]: [
    WIRES.setFacetsGroupsFromConfig,
    WIRES.setRemainingFacets
  ],
  [EVENTS.WindowSizeChanged]: [
    WIRES.calculateCorePosition,
    WIRES.detectDevice
  ],
  [EVENTS.KeyUp]: [
    WIRES.handleTabKeyPressed
  ],
  [EVENTS.SpellcheckSelected]: [
    WIRES.queryOriginSpellCheck,
    WIRES.changeQuery, // TODO: Refactor with emmit QueryChangeEvent
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.NewVersionDownloaded]: [
    WIRES.invalidateEmpathyAdapterCache
  ],
  [EVENTS.GetWishlistSuccess]: [
    WIRES.setWishlist,
    WIRES.mapWishlistToExistingResults
  ],
  [EVENTS.CallAddToWishlistClientEvent]: [
    WIRES.callAddToWishlistClientEvent
  ],
  [EVENTS.CallRemoveFromWishlistClientEvent]: [
    WIRES.callRemoveFromWishlistClientEvent
  ],
  [EVENTS.StateLoadedFromCache]: [
    WIRES.disableStateLoadedFromCache,
    WIRES.trackBackFromPDPQuery
  ]
};
